import { Component, Input } from '@angular/core';
import { DropdownItem } from '../../../models/form/basic';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-dropdown-option',
  standalone: true,
  imports: [NgClass],
  templateUrl: './dropdown-option.component.html',
  styleUrl: './dropdown-option.component.scss',
})
export class DropdownOptionComponent {
  @Input() item!: DropdownItem;
  @Input() icon?: string;
  @Input() placeholder = false;
  @Input() active = false;
}
